module.exports = __webpack_public_path__ + "static/media/clicky4.cdba72b4.gif";